import { makeStyles, Theme } from "@material-ui/core";
import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { RESULT_CODE } from "../types";
import { API_GATEWAY_URI } from "../contants/Server";
import { detect } from "detect-browser";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: "calc(var(--vh, 1vh) * 100)",
    display: "flex",
    flexDirection: "column",
  },
  body: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
  },
  textDiv: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2),
  },
  textCenter: {
    textAlign: "center",
  },
  marginB2: {
    marginBottom: theme.spacing(2),
  },
  link: {
    cursor: "pointer",
    color: "#2EA8E5",
    "&:hover, &:active": {
      color: "#0095E0",
    },
  },
  vcenter: {
    display: "flex",
    alignItems: "center",
  },
}));

export const FleetaAppDownloadScreen = () => {
  const classes = useStyles();

  const browser = detect();
  console.log("browser:", browser);

  const [loading, setLoading] = useState<boolean>(false);
  const [errMsg, setErrMsg] = useState<string>();
  const [linkUrl, setLinkUrl] = useState<string>(
    "https://blackvue.com/downloads"
  );

  const callStatistic = useCallback(async (os: string) => {
    try {
      setLoading(true);
      const resp = await axios.post(`${API_GATEWAY_URI}/qrcode?platform=${os}`);
      console.log("resp: ", resp);
      const { resultcode, message } = resp.data as {
        resultcode: RESULT_CODE;
        message: string;
      };
      if (resultcode === "BC_ERR_OK") {
        console.log("success call statistic!");
      } else {
        setErrMsg(message);
      }
    } catch (error: any) {
      console.log("error: ", error);
      setErrMsg(error);
    } finally {
      // if (platform === "IOS") {
      //   //@ts-ignore
      //   window.location.assign("https://apps.apple.com/us/app/blackvue/id1049209637");
      // }
      // if (platform === "AOS") {
      //   //@ts-ignore
      //   window.location.assign("https://play.google.com/store/apps/details?id=comb.blackvuec");
      // }
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (browser?.os === "iOS") {
      callStatistic("IOS");
      //@ts-ignore
      window.location.assign("https://apps.apple.com/app/fleeta/id6739498082");
      // setAppUrl("https://apps.apple.com/us/app/blackvue/id1049209637");
    } else if (browser?.os === "Android OS") {
      callStatistic("AOS");
      //@ts-ignore
      window.location.assign(
        "https://play.google.com/store/apps/details?id=comb.blackvuec.fleeta"
      );
      // setAppUrl("https://play.google.com/store/apps/details?id=comb.blackvuec");
    } else {
      //@ts-ignore
      window.location.assign("https://blackvue.com/downloads/");
    }
  }, [browser?.os, callStatistic]);

  return (
    <div className="App">
      {loading && <div className="App-loading"></div>}
      <div className={classes.root}>
        <div className={classes.body}>
          <div className={classes.textDiv}>
            {errMsg ? (
              errMsg
            ) : (
              <div
                className={classes.textCenter}
                onClick={() => {
                  window.location.replace(linkUrl);
                }}
              >
                <span>Go to</span>
                &nbsp;
                <span className={classes.link}>{"BlackVue"}</span>
                &nbsp;
                <span>app downloads</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
